module.exports = __webpack_public_path__ + "img/reagent.1c024b43.svg";